/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
saikrishna 11/25/2022  3031450488 Added BasicInfo new Ui fields
Sai Maheshwar 11/25/2022 3031450488 added reportFields components
akhila 11/25/2022 3031450488 Added props to additionalInfo
Sohel 11/25/2022  3031450488 Added Filters new Ui fields
Sohel 11/26/2022  3031450488 Filter Changes
Saikrishna 11/28/2022 2701350359 Added Stepper Click and styling functionality.
Gummala Prakash 11/28/2022 2701350359 Added spacing alignment.
akhila 1/12/2022 2701350359 Added workqueues
akhila 2/12/2022 2701350359 Added workqueues steps
akhila 3/12/2022 2701350359 changed imports for basicinfo and additionalInfo
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
Sai Maheshwar 12/05/2022 3031450488 added map fields save and close
Ravi 12/07/2022 3031450488 Fixed UAT bugs
Sai maheshwar 12/08/2022 3031450488 fixed unsaved changes alert bug
Lalitha 12/09/2022  3031450488  Added reusable backButtonText
Poornima 12/09/2022 3031450488 Added download configurations buttons
Sai maheshwar 12/12/2022 3031450488 fixed draft issue
Sohel 12/13/2022 3031450488 fixed completed step issue
Suresh peddavoora 12/21/2022 3031450488 Fixed stepper alignments in responsive
Lalitha 01/09/2023 3031450488 updated payload for work Queue
Rohini 02/09/2023 2698964415 Added the new classname
Saikrishna 09/02/2022 3031450488 fixed steppers  clickable issue
Prakash 02/13/2023 2701375033 Added padding spacing for cards.
Sohel 02/14/2023 3031450488 fixed report Copy data populate issue
Ravi 02/24/2023 3031450488 implemented previewFile in download Configuration
Akhila 03/02/2023 3031450488 Added loader and download toast message for preview File
Sohel 03/10/2023 3031450488 added StepIconComponent for showing Numbers in StepLabel

*/
import React, {useRef, useEffect, useState} from 'react';
import {
  Button,
  makeStyles,
  Stepper,
  StepLabel,
  Step,
  withStyles,
} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import reusableInputStyles from '../../../../components/InputStyles';
import BasicInfo from './StepperComponents/BasicInfo';
import ReportFields from './StepperComponents/ReportFields';
import axios from 'axios';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import Scheduler from './StepperComponents/Scheduler';
import AdditionalInfo from './StepperComponents/AdditionalInfo';
import Filters from './StepperComponents/Filters';
import {useDispatch, useSelector} from 'react-redux';
import StepConnector from '@material-ui/core/StepConnector';
import WorkQueueBasicInfo from './../../../Dashboard/WorkQueueMaintenance/BasicInfo';
import WorkQueueAdditionalInfo from './../../../Dashboard/WorkQueueMaintenance/AdditionalInfo';
import {setAlertData} from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import useUnsavedChangesWarning from '../../../../util/CustomHooks';
import {backButtonText, downloadButton} from '../../../../util/Content';
import {
  postPrintRecordMaster,
  postPrintWorkqueueMaster,
  ResetMessage as resetMessage,
  resetConfigUrl,
  resetDockey,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {REPORTING_EXPORT, WORK_QUEUE_SETUP} from '../../../../constants/ReusableRoleAccess';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../components/customStepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.85rem',
        },
      },
    },
  },
}));

const steps = ['Basic Info', 'Select Fields', 'Filters', 'Additional Info', 'Schedule'];
const Workqueuesteps = [
  'Basic Info',
  'Work Queue Fields',
  'Filters',
  'Additional Info',
  'Schedule',
];
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const AddReport = ({setTabValue, workQueue, setWorkQueue, editExisting}) => {
  const stepperClasses = useStyles();
  const dispatch = useDispatch();
  const classes = reusableInputStyles();
  const {isDraftReport, basicInfoData, lastStep} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const {isLoading, successMsg, errorMsg, configurationUrl, dockey} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  const {roleData} = useSelector(({role}) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  console.log(editExisting);
  const roleAccess =
    (workQueue && basicInfoData?.reportCode && !workQueueSetupAccess?.edit && editExisting) ||
    (!workQueue && basicInfoData?.reportCode && !reportRoleAccess?.edit && editExisting);

  const [activeStep, setActiveStep] = React.useState(lastStep);
  const showAlertRef = useRef(false);
  const {routerPrompt, onDirty, onPristine} = useUnsavedChangesWarning();
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const getStepContent = (index) => {
    switch (index) {
    case 0:
      return (
        <>
          {workQueue ? (
            <WorkQueueBasicInfo
              handleBack={handleBack}
              activeStep={activeStep}
              handleNext={handleNext}
              roleAccess={roleAccess}
              {...alertProps}
            />
          ) : (
            <BasicInfo
              handleBack={handleBack}
              activeStep={activeStep}
              handleNext={handleNext}
              workQueue={workQueue}
              roleAccess={roleAccess}
              {...alertProps}
            />
          )}
        </>
      );
    case 1:
      return (
        <ReportFields
          handleBack={handleBack}
          activeStep={activeStep}
          handleNext={handleNext}
          workQueue={workQueue}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 2:
      return (
        <Filters
          handleNext={handleNext}
          handleBack={handleBack}
          workQueue={workQueue}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 3:
      return (
        <>
          {workQueue ? (
            <WorkQueueAdditionalInfo
              handleBack={handleBack}
              handleNext={handleNext}
              setTabValue={setTabValue}
              workQueue={workQueue}
              editExisting={editExisting}
              {...alertProps}
            />
          ) : (
            <AdditionalInfo
              handleBack={handleBack}
              handleNext={handleNext}
              setTabValue={setTabValue}
              workQueue={workQueue}
              editExisting={editExisting}
              {...alertProps}
            />
          )}
        </>
      );
    case 4:
      return (
        <Scheduler
          setTabValue={setTabValue}
          handleBack={handleBack}
          {...alertProps}
          workQueue={workQueue}
          editExisting={editExisting}
        />
      );
    default:
      <p>InValid Step Index</p>;
    }
  };
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingConfig(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingConfig(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Reporting/Export'}
        name={workQueue ? 'Work Queue Name' : 'Report Name'}
        code={basicInfoData?.reportCode}
        description={workQueue ? 'Work Queue Description' : 'Report Description'}
        descriptionValue={basicInfoData?.reportDescription}
      />
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setTabValue(0);
                  },
                }),
              );
            } else {
              setTabValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {basicInfoData?.reportCode && (
          <Button
            type="button"
            variant="outlined"
            className={`search-btn ml-2 ${classes.buttonRoot}`}
            // disabled={Boolean(countTotal === 0)}
            onClick={() => {
              if (workQueue) {
                dispatch(
                  postPrintWorkqueueMaster({
                    description: basicInfoData?.reportDescription ?
                      basicInfoData.reportDescription :
                      '',
                    code: basicInfoData?.reportCode ? basicInfoData.reportCode : '',
                    orderBy: '',
                    orderDirection: '',
                    // reportTitle: basicInfoData?.reportTitle ? basicInfoData?.reportTitle : "",
                    createdFor: basicInfoData?.createdFor ? basicInfoData?.createdFor : '',
                    isDraft: basicInfoData?.isDraft?.key ? basicInfoData?.isDraft?.key : '',
                    createdBy: '',
                    createdDate: '',
                  }),
                );
              } else {
                dispatch(
                  postPrintRecordMaster({
                    reportDescription: basicInfoData?.reportDescription ?
                      basicInfoData.reportDescription :
                      '',
                    reportCode: basicInfoData?.reportCode ? basicInfoData.reportCode : '',
                    orderBy: '',
                    orderDirection: '',
                    reportTitle: basicInfoData?.reportTitle ? basicInfoData?.reportTitle : '',
                    createdFor: basicInfoData?.createdFor ? basicInfoData?.createdFor : '',
                    isDraft: basicInfoData?.isDraft?.key ? basicInfoData?.isDraft?.key : '',
                  }),
                );
              }
            }}
          >
            {downloadButton}
          </Button>
        )}
      </div>
      {routerPrompt}
      <div className={classes.root} style={{border: '1px solid #cfcfcf'}}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {(workQueue ? Workqueuesteps : steps).map((label, i) => (
            <Step
              key={label}
              onClick={() => {
                if (
                  i < activeStep ||
                  i < lastStep ||
                  // (label !== "Schedule" && isDraftReport === "N") ||
                  isDraftReport === 'N' ||
                  i <= basicInfoData?.lastStep
                ) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(i);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(i);
                  }
                }
              }}
              completed={
                i <= lastStep ||
                // (label !== "Schedule" && isDraftReport === "N") ||
                isDraftReport === 'N' ||
                i < activeStep ||
                i < basicInfoData?.lastStep
              }
              style={{cursor: 'pointer'}}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === i ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1.2rem 0.5rem'}}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      {(isLoading || isLoadingConfig) && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default AddReport;
